import { noop, Observable } from 'rxjs';
import { pairwise, share, tap } from 'rxjs/operators';
import { createProjectingService } from './projectingService';
import { createService, NULL_SERVICE, Service } from './service';

export function createConnectingService<T, S extends Service>(
  target$: Observable<T | null>,
  getDisconnectedService: () => S,
  getConnectedService: (target: T) => S,
  onServiceChange: (nextService: S, prevService: S) => void = noop,
): S {
  return createProjectingService(
    null,
    target$,
    target => (target ? getConnectedService(target) : getDisconnectedService()),
    service$ =>
      service$.pipe(
        pairwise(),
        tap(([prevService, nextService]) => onServiceChange(nextService, prevService)),
        share(),
      ),
  );
}

export function createConnectingEffectService<T>(
  target$: Observable<T | null>,
  getEffects$: (target: T) => Observable<any>,
): Service {
  return createConnectingService(
    target$,
    () => NULL_SERVICE,
    target =>
      createService({
        effects$: getEffects$(target),
      }),
  );
}
